import { useParams } from "react-router-dom";
import products from "../data/products";

export default function ProductDetail() {
  const { slug } = useParams();
  const product = products.find((p) => p.slug === slug);

  const handleBuyNow = async () => {
    const email = localStorage.getItem("userEmail");
    if (!email) {
      alert("Please login before purchasing.");
      return;
    }

    const productSlug = product.slug;

    try {
      const res = await fetch("https://jivangaming.in/backend/create-order.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: product.price * 100,
          email,
          slug: productSlug,
        }),
      });

      const data = await res.json();
      if (!data.success) {
        alert("Failed to initiate payment.");
        return;
      }

      const options = {
        key: "rzp_live_wiSDsxIkTdy6s8",
        amount: data.amount,
        currency: "INR",
        name: "Jivan Gaming",
        description: product.name,
        order_id: data.orderId,
        handler: async function () {
          const links = {
             "sensi-advance-pack-android" : "https://drive.google.com/drive/folders/1A1J5U45s-ts3DKmxG8nD7Zdn1LwvJZ8k", 
            "sensi-premium-pack-android": "https://drive.google.com/drive/folders/1Klsm0AxHLBDewTOrcS1XvmLuMgDYbYJf",
            "free-fire-red-button-iphone": "https://drive.google.com/drive/folders/1IRcP5QvZ9lARK4kFtWj_8DwOaaJx8pkn",
            "best-sensitivity-io-free-fire-max": "https://drive.google.com/drive/folders/1y1rtYeG0XBMBP3khxjG2EJrAryoXZ07o",
            "lag-fix-free-fire-course": "https://drive.google.com/drive/folders/1DcHfukzRrHn2PyZQ_Z3Cw0NgCsOP8qcL",
            "premium-sensi-for-android": "https://drive.google.com/drive/folders/1Klsm0AxHLBDewTOrcS1XvmLuMgDYbYJf",
            "NEW-SENSI-SHOTGUN-METHOD":"https://drive.google.com/drive/folders/1_-kkiUOwoPvjrLwr2jc5Pes_2jDLiFD_",
          };

          const link = links[productSlug];

          if (link) {
            // ✅ Save purchase to backend
            try {
              await fetch("https://jivangaming.in/backend/save-purchase.php", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  email,
                  slug: productSlug,
                  link,
                }),
              });
            } catch (err) {
              console.error("Failed to save purchase", err);
            }

            alert("✅ Payment successful! Click OK to access your course.");
            window.open(link, "_blank");
          } else {
            alert(`❌ Product link not found for slug: ${productSlug}`);
          }
        },
        prefill: {
          email,
        },
        theme: {
          color: "#000",
        },
      };

      const razor = new window.Razorpay(options);
      razor.open();
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    }
  };

  if (!product) {
    return (
      <div className="text-center mt-10 text-red-500">Product not found.</div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <img
        src={product.image}
        alt={product.name}
        className="w-64 h-auto mb-6"
      />
      <h1 className="text-2xl font-bold mb-2">{product.name}</h1>
      <p className="text-lg mb-4">
        {product.description || "No description available."}
      </p>
      <p className="text-green-600 font-semibold mb-6">
        Price: ₹{product.price}
      </p>
      <button
        onClick={handleBuyNow}
        className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800 transition"
      >
        Buy Now
      </button>
    </div>
  );
}
